export default __webpack_public_path__ + "adobe-coldfusion.8d7a1a2a.png";